import compact from 'lodash/compact'
import { DisplayMode } from 'modules/water/api/types'
import { useMemo } from 'react'
import { useRecoilValue } from 'recoil'

import { selectedMedicineIdState } from '../stores/atom'
import { useGetMedicinesByRange, useGetMedicineSummaryByToday } from './queries'

export const useMedicines = (mode: DisplayMode, startDate?: Date, endDate?: Date) => {
  const { data, ...rest } = useGetMedicinesByRange(mode, startDate, endDate)

  return useMemo(
    () => ({
      ...rest,
      data: compact((data?.pages ?? []).map((page) => page.medicines).flat()),
    }),

    [data, mode]
  )
}

export const useMedicinesSummaryToday = () => {
  const { data, ...rest } = useGetMedicineSummaryByToday()

  return useMemo(
    () => ({
      ...rest,
      data,
    }),

    [data]
  )
}

export const useFindMedicineById = () => {
  const id = useRecoilValue(selectedMedicineIdState)
  const { data } = useMedicines('table')
  return useMemo(() => data.find((el) => el.id === id), [data, id])
}
